// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueCurrencyFilter from 'vue-currency-filter'
import VCurrencyField from 'v-currency-field'
import 'v-currency-field/dist/index.css'
import store from '../src/store/main.js';

 
Vue.use(VCurrencyField)

// import money from 'v-money';

Vue.use(VueCurrencyFilter, {
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 4,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
});

Vue.use(Vuetify, {
  theme: {
    primary: '#1976D2',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.config.productionTip = false

Vue.prototype.$eventHub = new Vue({
  store,
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js